import React from 'react';
import { List, Datagrid, TextField, NumberField, BooleanField, UrlField, DateField } from 'admin-on-rest';
import CHEurField from '../utils/CHEurField'

export const BidhistoryList = (props) => (
    <List title="Biedingen history" perPage={100} {...props}>
        <Datagrid>
            <CHEurField source="bid" sortable={false} />
            <DateField source="started_on" sortable={false} showTime  />
            <TextField source="company_name" sortable={false} />
            <TextField source="website_url" sortable={false} />
		</Datagrid>
    </List>
);



// WEBPACK FOOTER //
// ./src/bidhistory/Bidhistory.js